import { baseApiURL } from "./default";
import { ConfigSchema } from "./types/config";

export async function loadConfig(): Promise<ConfigSchema> {
    const r = await fetch(baseApiURL + '/config.json')
    const conf = await r.json() as ConfigSchema;
    return conf;
}

